var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubeGrandeCentradaNaranjaBirdybuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 75,
    viewBox: "0 0 325 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1119 0H311.702C319.05 0 325 5.97751 325 13.36C325 20.7425 319.05 26.72 311.702 26.72H149.711C144.346 26.72 139.998 31.0882 139.998 36.4782C139.998 41.8682 144.346 46.2364 149.711 46.2364H272.342C280.25 46.2364 286.657 52.6737 286.657 60.6182C286.657 68.5627 280.25 75 272.342 75H46.2251C38.7498 75 32.6729 68.9203 32.6729 61.3845C32.6729 53.8743 38.7244 47.7691 46.2251 47.7691H80.685C84.3743 47.7691 87.365 44.7783 87.365 41.0891C87.365 37.3998 84.3743 34.4091 80.685 34.4091H17.1119C7.65329 34.4091 0 26.72 0 17.2173C0 7.71455 7.65329 0.0255309 17.1119 0.0255309V0Z",
    fill: "#FFD2B0",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubeGrandeCentradaNaranjaBirdybuyer);
export default __webpack_public_path__ + "static/media/nube-grande-centrada-naranja-birdybuyer.01c4b93180439635ffebbe240a3f8815.svg";
export { ForwardRef as ReactComponent };